package com.starparty.app.astro0.renderers

import com.starparty.app.astro0.*
import com.starparty.app.geometry.SP_Point

class SkyRenderer constructor(val itsSky:Sky) {

    val starDataURL = "resources/sorted_stars.dat"
    val conDataURL = "resources/constellations.dat"

    val DEF_INCREMENT = 2500.0
    val MAX_INCREMENT = 5.0
    val DEF_LATITUDE: Double = UMS.Companion.unitMinSecToDecimal("50 4 40")
    val DEF_LONGITUDE: Double = UMS.Companion.unitMinSecToDecimal("5 42 12")
    protected var itsIncrement = 0.0
    protected var itsRollIncrement = 5.0
    protected var itsOffsetIncrement = 5
    protected var itsZoomIncrement = 0.95

    fun onDraw(canvas: SP_Canvas, rendererTheme: RendererTheme) {

        canvas.drawColor(rendererTheme.backgroundPaint)
        paintGrids(canvas, rendererTheme)
        DSOFieldRenderer.paint(itsSky.deepSkyField, itsSky.showLabels, canvas, rendererTheme)
        StarFieldRenderer.paint(itsSky.starField, itsSky.showLabels, canvas, rendererTheme)
        OrreryRenderer.paint(itsSky.orrery, itsSky.showLabels, canvas, rendererTheme)

        //  displayTimeAndDate(canvas, rendererTheme)
        //  displayLocation(canvas, rendererTheme)

        drawCentreMarker(canvas, rendererTheme)
    }

    fun drawCentreMarker(canvas: SP_Canvas, rt: RendererTheme) {
        val midX = canvas.getCentreX()
        val midY = canvas.getCentreY() //-canvas.height * (1.0/5.0)

        val p = rt.centreMarkerPaint
        canvas.drawCircleUnfilled(midX, midY,20.0, p)
    }

    private fun displayTimeAndDate(g: SP_Canvas, rendererTheme: RendererTheme){

        val equGridLabelPaint = rendererTheme.equGridLabelsPaint

        var point = SP_Point(180.0,-880.0)
        var label = "UTC: ${itsSky.getTime().hourOfDayUTC()}:${itsSky.getTime().minuteUTC()}:${itsSky.getTime().secondUTC()}"
        TextRenderer.paintLabel(
            g,
            equGridLabelPaint,
            point,
            label
        )

        point = SP_Point(180.0,-850.0)
        label = "Date: ${itsSky.getTime().year}-${itsSky.getTime().monthUTC()}-${itsSky.getTime().dayOfMonthUTC()}"
        TextRenderer.paintLabel(
            g,
            equGridLabelPaint,
            point,
            label
        )
    }
/* Commented out because only used / works in Android version
    private fun displayLocation(g: SP_Canvas, rendererTheme: RendererTheme) {

        val equGridLabelPaint = rendererTheme.equGridLabelsPaint

        var latFormatted = itsSky.getPlace().formattedLatitudeDecimal(3)
        var lonFormatted = itsSky.getPlace().formattedLongitudeDecimal(3)

        var point = SP_Point(180.0,-800.0)
        var label = "Lat: $latFormatted"
        TextRenderer.paintLabel(
            g,
            equGridLabelPaint,
            point,
            label
        )

        point = SP_Point(180.0,-770.0)
        label = "Lon: $lonFormatted"
        TextRenderer.paintLabel(
            g,
            equGridLabelPaint,
            point,
            label
        )
    }
*/
    private enum class State {
        NONE, DRAG, ZOOM
    }

    private var state =
        State.NONE
    private val last = SP_Point()
    private fun setState(state: State) {
        this.state = state
    }

    protected fun paintGrids(g: SP_Canvas, rendererTheme: RendererTheme) {
        val altAzmGridType = itsSky.showAltAzmGridType
        if (altAzmGridType == Sky.FULL_GRID || altAzmGridType == Sky.BOTH_GRIDS) {
            val paint = rendererTheme.altAzmGridPaint
            GridRenderer.paintWholeGrid(itsSky.altAzmGrid, g, paint)
        }
        if (altAzmGridType == Sky.ZERO_GRID || altAzmGridType == Sky.BOTH_GRIDS) {
            val aaGridPaint = rendererTheme.altAzmZeroGridPaint
            val horizonPaint = rendererTheme.horizonPaint

            GridRenderer.paintAllLongitudeLines(itsSky.altAzmZeroGrid, g, aaGridPaint)
            GridRenderer.paintAllLatitudeLines(itsSky.altAzmZeroGrid, g, horizonPaint)
        }

        val equGridType = itsSky.showEquGridType
        if (equGridType == Sky.FULL_GRID || equGridType == Sky.BOTH_GRIDS) {
            val paint = rendererTheme.equGridPaint
            GridRenderer.paintWholeGrid(itsSky.equGrid, g, paint)
        }
        if (equGridType == Sky.ZERO_GRID || equGridType == Sky.BOTH_GRIDS) {
            val equGridPaint = rendererTheme.equZeroGridPaint
            val equatorPaint = rendererTheme.equatorPaint

            GridRenderer.paintAllLongitudeLines(itsSky.equZeroGrid, g, equGridPaint)
            GridRenderer.paintAllLatitudeLines(itsSky.equZeroGrid, g, equatorPaint)
        }

        if (itsSky.showLabels > 0) {
            paintGridLabels(g, rendererTheme)
        }
    }

    protected fun paintGridLabels(g: SP_Canvas,
                                  rendererTheme: RendererTheme) {
        val aaGridLabelPaint = rendererTheme.altAzmGridLabelsPaint
        val equGridLabelPaint = rendererTheme.equGridLabelsPaint

        var point = itsSky.zenith
        var label = GridRenderer.ZENITH_LABEL
        TextRenderer.paintLabel(
            g,
            equGridLabelPaint,
            point,
            label
        )
        point = itsSky.nadir
        label = GridRenderer.NADIR_LABEL
        TextRenderer.paintLabel(
            g,
            equGridLabelPaint,
            point,
            label
        )
        point = itsSky.north
        label = GridRenderer.N_LABEL
        TextRenderer.paintLabel(
            g,
            aaGridLabelPaint,
            point,
            label
        )
        point = itsSky.south
        label = GridRenderer.S_LABEL
        TextRenderer.paintLabel(
            g,
            aaGridLabelPaint,
            point,
            label
        )
        point = itsSky.east
        label = GridRenderer.E_LABEL
        TextRenderer.paintLabel(
            g,
            aaGridLabelPaint,
            point,
            label
        )
        point = itsSky.west
        label = GridRenderer.W_LABEL
        TextRenderer.paintLabel(
            g,
            aaGridLabelPaint,
            point,
            label
        )
    }



    init {
        val starDataURL = starDataURL
        val conDataURL = conDataURL
      //  val starsId = R.raw.stars
      //  val constellationsId = R.raw.constellations
        //InputStream starsIS = context.getResources().openRawResource(starsId);
        //InputStream constellationsIS = context.getResources().openRawResource(constellationsId);
        //   resetIncrement();


        // setBackground(Color.blue);
        itsSky.project()

        //  setToolTipText("");
        //  ToolTipManager.sharedInstance().setDismissDelay(Time.MINS_TO_MS);
        itsSky.centerPoint = itsSky.centerPoint
    //    m_scaleGestureDetector = ScaleGestureDetector(context, ScaleListener())
    }
}